import React, { useState } from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker } from 'react-dates';
import { eachDayOfInterval, isWeekend, format } from 'date-fns';
import Holidays from 'date-holidays';
import moment from "moment";
const hd = new Holidays('CL'); // 🇨🇱 Chile

export const VacationSelect = ({dateRange, setDateRange, setTotalDiasHabiles}) => {



  const [focusedInput, setFocusedInput] = useState(null);

  // Función para calcular días hábiles con logs
  const getWorkingDays = (startDate, endDate) => {
    if (!startDate || !endDate) return 0;

    // Convertir a fechas sin hora para evitar errores
    const start = new Date(startDate);
    const end = new Date(endDate);

    // console.log('📅 Rango de Fechas Seleccionado:');
    // console.log('  - Fecha de Inicio:', format(start, 'yyyy-MM-dd'));
    // console.log('  - Fecha de Fin:', format(end, 'yyyy-MM-dd'));

    // Obtener todos los días en el intervalo
    const allDays = eachDayOfInterval({ start, end });
    // console.log('📌 Días en el intervalo:', allDays.map(d => format(d, 'yyyy-MM-dd')));

    // Obtener feriados de Chile para los años en el intervalo
    const yearsInRange = new Set([start.getFullYear(), end.getFullYear()]);
    let feriados = [];
    
    yearsInRange.forEach(year => {
      const holidays = hd.getHolidays(year).map(f => format(new Date(f.date), 'yyyy-MM-dd'));
      feriados = [...feriados, ...holidays];
    //   console.log(`🎉 Feriados en ${year}:`, holidays);
    });

    // console.log('📌 Lista completa de feriados:', feriados);

    // Filtrar días hábiles (excluyendo fines de semana y feriados)
    const workingDays = allDays.filter(day => {
      const formattedDay = format(day, 'yyyy-MM-dd');
      const isWeekendDay = isWeekend(day);
      const isHoliday = feriados.includes(formattedDay);

    //   console.log(`🔎 Día ${formattedDay} - Es fin de semana: ${isWeekendDay} - Es feriado: ${isHoliday}`);
      
      return !isWeekendDay && !isHoliday;
    });

    console.log('✅ Días hábiles encontrados:', workingDays.map(d => format(d, 'yyyy-MM-dd')));
    console.log('📊 Total días hábiles:', workingDays.length);

    return workingDays.length;
  };

  const totalDiasHabiles = getWorkingDays(dateRange.startDate, dateRange.endDate);

  setTotalDiasHabiles(totalDiasHabiles)

  return (
    <div style={{ margin:'0 auto', width:'fit-content' }} >
      {/* <h2>Selecciona tu rango de vacaciones</h2> */}
      <DateRangePicker
        startDate={dateRange.startDate}
        startDateId="start_date_id"
        endDate={dateRange.endDate}
        endDateId="end_date_id"
        onDatesChange={({ startDate, endDate }) => {
        setDateRange({
            startDate: startDate ? moment(startDate) : null,
            endDate: endDate ? moment(endDate) : null,
        });
      }}
        displayFormat="DD/MM/YYYY" //
        focusedInput={focusedInput}
        onFocusChange={(focused) => setFocusedInput(focused)}
      />
      {/* <p>Total de días hábiles seleccionados: {totalDiasHabiles}</p> */}
    </div>
  );
};

export default VacationSelect;
